module.exports = __webpack_public_path__ + "static/01-5291df060a37e53399562a1d6bc9b954.jpg";